import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import plansEntryTop from 'assets/img/plans/entry-top.png';
import plansPremiumTop from 'assets/img/plans/premium-top.png';
import plansEliteTop from 'assets/img/plans/elite-top.png';
import plansPetrolTop from 'assets/img/plans/petrol-top.png';
import plansEntryButton from 'assets/img/plans/entry-button.png';
import plansPremiumButton from 'assets/img/plans/entry-button.png';
import plansEliteButton from 'assets/img/plans/elite-button.png';
import plansPetrolButton from 'assets/img/plans/petrol-button.png';
import particlesImage from 'assets/img/particles.png';
import petrolImage from 'assets/img/row-petrol.png';

/* eslint-disable */
export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\\.,;:\s@"]+\.)+[^<>()[\]\\.,;:\s@"]{2,})$/
    );
};

export const validatePhone = (value) => {
  if (!value || value.includes('@')) return false;

  const digits = value.replace(/\D/g, ''); 
  return digits.length >= 6;
};

/* eslint-enable */

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0); 
    }, [pathname]);

    return null;
};
export default ScrollToTop;

export const validateLoadMore = (data, meta) => {
  if (data?.length < meta?.total && meta?.offset + meta?.limit < meta?.total) {
    return true;
  }

  return false;
};

export const getDiscount = (item) => {
  const plans = item?.discountInfo?.plans ?? {};
  const currentPlan =
    Object.values(plans).find((plan) => plan?.isCurrent) ||
    item?.discountInfo?.plans?.entry;

  if (!currentPlan && !item?.discountInfo) { return ''; }

  let value = '';

  const discountValue =
    currentPlan?.discount > 0
      ? currentPlan?.discount
      : (item?.discountInfo?.discount === '0%' ||
          item?.discountInfo?.discount === '0$')
      ? 'SPECIAL'
      : item?.discountInfo?.discount;

  // добавляем символ валюты В НАЧАЛЕ
  if (currentPlan?.isCurrency && currentPlan?.discount > 0) {
    value = `$${discountValue}`;
  } else if (!currentPlan?.isCurrency && currentPlan?.discount > 0) {
    value = `${discountValue}%`;
  } else {
    value = discountValue;
  }

  if (currentPlan?.discount > 0) { value += ' Discount'; }

  return value !== 'null' ? value : '';
};

export const drawCircleOnMap = (map, center, radiusInKm) => {
  const points = 64; 
  const coords = {
    latitude: center.lat,
    longitude: center.long
  };

  const km = radiusInKm;
  const ret = [];
  const distanceX = km / (111.320 * Math.cos(coords.latitude * Math.PI / 180));
  const distanceY = km / 110.574;

  let theta, x, y;
  for (let i = 0; i < points; i++) {
    theta = (i / points) * (2 * Math.PI);
    x = distanceX * Math.cos(theta);
    y = distanceY * Math.sin(theta);

    ret.push([coords.longitude + x, coords.latitude + y]);
  }
  ret.push(ret[0]); 

  const circleFeature = {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [ret]
    }
  };

  if (map.getSource('circle')) {
    map.getSource('circle').setData(circleFeature);
  } else {
    map.addSource('circle', {
      type: 'geojson',
      data: circleFeature
    });

    map.addLayer({
      id: 'circle-fill',
      type: 'fill',
      source: 'circle',
      paint: {
        'fill-color': '#2ABDFD',
        'fill-opacity': 0.1
      }
    });

    map.addLayer({
      id: 'circle-outline',
      type: 'line',
      source: 'circle',
      paint: {
        'line-color': '#2ABDFD',
        'line-width': 1
      }
    });
  }
};

export const hexToRgba = (hex: string, alpha: number) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const validatePassword = (password) => {
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumber = /\d/.test(password);

  if (!hasUpperCase || !hasLowerCase || !hasNumber || password.length < 8) {
    return false;
  }

  return true;
};

export const user = () => {
  return JSON.parse(localStorage.getItem('auth')) ?? false;
};

export const parseNum = (n) => {
  if(0 <= n && n < 10000){
    return n;
  } else if(10000 <= n && n < 1000000) {
    return (Math.floor(n / 1000)) + 'K';
  } else if(1000000 <= n) {
    return (Math.floor(n / 1000000)) + 'M';
  } 
};

export const getInitials = (firstName, lastName) => {
  if (!firstName && !lastName) { 
    return ''; 
  }

  const firstInitial = firstName ? firstName.charAt(0) : '';
  const lastInitial = lastName ? lastName.charAt(0) : '';
  return `${firstInitial}${lastInitial}`.toUpperCase();
};

export const parseDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); 
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const parseDateBirthday = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); 
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
};

export const parseDateTime = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); 
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${hours}:${minutes} ${day}/${month}/${year}`;
};

export const parseFullDate = (isoDate) => {
  if (!isoDate) { return 'Soon'; }

  try {
    const date = new Date(isoDate);
    const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const dayOfWeek = daysOfWeek[date.getDay()];

    const day = date.getDate();
    const suffix = (day) => {
        if (day >= 11 && day <= 13) { return 'th'; }
        switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    };

    const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const month = months[date.getMonth()];

    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = 'AM';

    if (hours >= 12) {
        ampm = 'PM';
        if (hours > 12) { hours -= 12; }
    }
    if (hours === 0) { hours = 12; }
    minutes = minutes < 10 ? `0${minutes}` : minutes;

    return `${dayOfWeek} ${day}${suffix(day)} of ${month} at ${hours}:${minutes}${ampm}`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Soon';
  }
};

export const formatDateTime = (isoDate) => {
    if (!isoDate) { return 'Ended'; }

    try {
        const date = new Date(isoDate);

        let hours = date.getHours();
        let minutes = date.getMinutes();
        let ampm = 'am';

        if (hours >= 12) {
            ampm = 'pm';
            if (hours > 12) { hours -= 12; }
        }
        if (hours === 0) { hours = 12; }
        minutes = minutes < 10 ? `0${minutes}` : minutes;

        // Получаем день
        const day = date.getDate();

        // Получаем месяц
        const months = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];
        const month = months[date.getMonth()];

        // Получаем год
        const year = date.getFullYear();

        return `${hours}:${minutes}${ampm} ${day} ${month} ${year}`;
    } catch (error) {
        console.error('Error formatting date:', error);
        return 'Ended';
    }
};

export const countdownTimer = (targetDate, setTimeLeft) => {
  if (!targetDate) { return; }

  const updateTimer = () => {
    const now = new Date();
    const eventDate = new Date(targetDate);

    const diffMs = eventDate - now;

    if (diffMs <= 0) {
      setTimeLeft('');
      return;
    }

    const totalDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

    let formattedTime = '';
    if (totalDays > 0) {
      formattedTime += `${String(totalDays).padStart(2, '0')}d `;
    }
    formattedTime += `${String(hours).padStart(2, '0')}h `;
    formattedTime += `${String(minutes).padStart(2, '0')}m `;
    formattedTime += `${String(seconds).padStart(2, '0')}s`;

    setTimeLeft(formattedTime.trim());
  };

  updateTimer();
  const interval = setInterval(updateTimer, 1000);

  return () => clearInterval(interval);
};

export const numdownTimer = (targetDate, setTimeLeft) => {
  if (!targetDate) { return; }

  const updateTimer = () => {
    const now = new Date();
    const eventDate = new Date(targetDate);

    const diffMs = eventDate - now;

    if (diffMs <= 0) {
      setTimeLeft('0');
      return;
    }

    const secondsPassed = Math.floor(diffMs / 1000);
    setTimeLeft(secondsPassed.toString());
  };

  updateTimer();
  const interval = setInterval(updateTimer, 1000);

  return () => clearInterval(interval);
};

export const maskEmail = (email) => {
  const getStars = (min = 3, max = 6) =>
    '*'.repeat(Math.floor(Math.random() * (max - min + 1)) + min);

  const [local, domain] = email.split('@');

  const maskedLocal = local.slice(0, 3) + getStars();

  const [domainName, tld = ''] = domain.split('.');
  const maskedDomain = domainName.slice(0, 1) + getStars();
  const maskedTld = tld.slice(0, 1) + getStars();

  return `${maskedLocal}@${maskedDomain}.${maskedTld}`;
};

export const formatDateTicket = (isoString) => {
  const date = new Date(isoString);

  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear() % 100; 

  const hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0'); 

  return `${day}/${month}/${year}, ${hours}:${minutes}`;
};

export const getDaysLeft = (isoDate) => {
  const targetDate = new Date(isoDate);
  const now = new Date();
  const diff = targetDate - now;
  if (diff <= 0) {return 0;}
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
};

export const formatDateWithSuffix = (isoDate) => {
    if (!isoDate) {return '';}

    const date = new Date(isoDate);
    const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const getDaySuffix = (day) => {
        if (day >= 11 && day <= 13) {return 'th';}
        switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    };

    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${month} ${day}${getDaySuffix(day)}, ${year}`;
};

export const parseNotifyDate = (dateString) => {
  const date = new Date(dateString);

  const now = new Date();
  const secondsPast = (now.getTime() - date.getTime()) / 1000;

  if (secondsPast < 60) { // < 1m
    return 'Just now';
  }
  if (secondsPast < 3600) { // <  1h
    const minutes = Math.floor(secondsPast / 60);
    return `${minutes} min. ago`;
  }
  if (secondsPast < 86400) { // < 1day
    const hours = Math.floor(secondsPast / 3600);
    return `${hours}h. ago`;
  }

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

const names = [
  'Jack', 'Olivia', 'Noah', 'Isla', 'Leo', 'Amelia', 'Lucas', 'Charlotte', 'Ethan', 'Ava',
  'Hudson', 'Mia', 'Henry', 'Grace', 'William', 'Evie', 'Thomas', 'Willow', 'James', 'Ella',
  'Alexander', 'Matilda', 'Liam', 'Sophie', 'Harry', 'Ruby', 'Mason', 'Zoe', 'Charlie', 'Lily',
  'Archie', 'Hannah', 'Hunter', 'Ivy', 'Max', 'Emily', 'Archer', 'Harper', 'Oscar', 'Abigail',
  'Levi', 'Scarlett', 'Samuel', 'Chloe', 'Elijah', 'Summer', 'Logan', 'Sienna', 'Xavier', 'Florence',
  'Jayden', 'Zara', 'George', 'Layla', 'Jaxon', 'Aaliyah', 'Patrick', 'Freya', 'Riley', 'Mila',
  'Lincoln', 'Thea', 'Beau', 'Ellie', 'Sebastian', 'Poppy', 'Flynn', 'Luna', 'Harvey', 'Millie',
  'Nate', 'Savannah', 'Connor', 'Elsie', 'Jasper', 'Daisy', 'Theo', 'Aurora', 'Edward', 'Maddison',
  'Jordan', 'Hazel', 'Kai', 'Bella', 'Austin', 'Olive', 'Ezra', 'Penelope', 'Spencer', 'Frankie',
  'Aiden', 'Indiana', 'Wyatt', 'Phoebe', 'Caleb', 'Bonnie', 'Isaac', 'Maeve', 'Tyler', 'Piper'
];

export const getRandomNames = (count) => {
  const shuffled = [...names].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count).map(name => {
    const letter = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[Math.floor(Math.random() * 26)];
    return `${name} ${letter}.`;
  });
};

export const colorUserSubLayout = (type) => {
  if(type === 'entry'){
    return 'linear-gradient(165deg, #F3B785 1.03%, #ECA973 26.88%, #D58049 60.4%, #D07741 96.79%)';
  } else if(type === 'premium'){
    return 'linear-gradient(105deg, #555282 28.72%, #6A659F 42.86%, #7A78A2 56.38%, #9B94C7 77.9%, #B8B4DA 90.2%)';
  } else if(type === 'elite'){
    return 'linear-gradient(94deg, #E1A31A 58.05%, #EAB639 67%, #F6CE5F 79.3%, #FCDD76 88.99%, #FFE27F 95.33%)';
  } else if(type === 'fuel'){
    return 'linear-gradient(267deg, #C2C2C2 1.36%, #B7B5B3 16.4%, #817F7E 35.89%, #817F7E 57.06%)';
  } else {
    return 'linear-gradient(185deg, #2ABDFD 3.71%, #0497FD 95.16%)';
  }
};

export const colorUserSubBg = (type) => {
  if(type === 'entry'){
    return 'linear-gradient(165deg, #F3B785 1.03%, #ECA973 26.88%, #D58049 60.4%, #D07741 96.79%)';
  } else if(type === 'premium'){
    return 'linear-gradient(329deg, #555282 10.12%, #6A659F 27.21%, #7A78A2 43.55%, #9B94C7 69.55%, #B8B4DA 84.4%)';
  } else if(type === 'elite'){
    return 'linear-gradient(352deg, #E1A31A 14.49%, #EAB639 46.41%, #F6CE5F 90.29%, #FCDD76 124.87%, #FFE27F 147.47%), rgba(255, 255, 255, 0.10)';
  } else if(type === 'fuel'){
    return 'linear-gradient(168deg, #E9E8E7 24.92%, #BCBAB8 48.33%, #817F7E 78.69%, #524F4E 111.64%)';
  } else {
    return 'transparent';
  }
};

export const plansBgCard = (type, isDark) => {
  if(type === 'entry'){
    return isDark ? '#0E1633' : 'linear-gradient(326deg, #fdf6f0 50%, #faf3ec 50%)';
  } else if(type === 'premium'){
    return isDark ? '#0E1633' : 'linear-gradient(326deg, #f5f0ff 50%, #f1ecfa 50%)';
  } else if(type === 'elite'){
    return isDark ? '#0E1633' : 'linear-gradient(352deg, #fffcf0 50%, #faf7ec 50%)';
  } else if(type === 'fuel'){
    return isDark ? '#0E1633' : 'linear-gradient(352deg, #f7f7f6 50%, #f0f0f0 50%)';
  } else {
    return 'transparent';
  }
};

export const plansBgTop= (type) => {
  if(type === 'entry'){
    return plansEntryTop;
  } else if(type === 'premium'){
    return plansPremiumTop;
  } else if(type === 'elite'){
    return plansEliteTop;
  } else if(type === 'fuel'){
    return plansPetrolTop;
  } else {
    return plansEntryTop;
  }
};

export const plansBorderColor= (type) => {
  if(type === 'entry'){
    return '#CE853F';
  } else if(type === 'premium'){
    return '#773FCE';
  } else if(type === 'elite'){
    return '#E1A31A';
  } else if(type === 'fuel'){
    return '#BCBAB8';
  } else {
    return 'rgba(188, 186, 184, 0.10';
  }
};

export const plansIconBgColor= (type, isDark) => {
  const color = isDark ? '#0E1633' : '#fff';
  if(type === 'entry'){
    return `linear-gradient(329deg, rgba(206, 133, 63, 0.30) 10.12%, rgba(219, 140, 64, 0.30) 27.21%, rgba(227, 150, 77, 0.30) 43.55%, rgba(255, 179, 107, 0.30) 69.55%, rgba(255, 200, 148, 0.30) 84.4%), ${color}`;
  } else if(type === 'premium'){
    return `linear-gradient(329deg, rgba(119, 63, 206, 0.30) 10.12%, rgba(124, 64, 219, 0.30) 27.21%, rgba(135, 77, 227, 0.30) 43.55%, rgba(165, 107, 255, 0.30) 69.55%, rgba(182, 137, 253, 0.30) 84.4%), ${color}`;
  } else if(type === 'elite'){
    return `linear-gradient(333deg, rgba(225, 163, 26, 0.30) 9.41%, rgba(234, 182, 57, 0.30) 36.49%, rgba(246, 206, 95, 0.30) 73.73%, rgba(252, 221, 118, 0.30) 103.07%, rgba(255, 226, 127, 0.30) 122.25%), ${color}`;
  } else if(type === 'fuel'){
    return `linear-gradient(180deg, rgba(188, 186, 184, 0.30) 0%, rgba(104, 102, 101, 0.30) 100%), ${color}`;
  }
};

export const plansItemColor= (type, isDark) => {
  if(type === 'entry'){
    return '#CE853F';
  } else if(type === 'premium'){
    return '#773FCE';
  } else if(type === 'elite'){
    return '#E1A31A';
  } else if(type === 'fuel'){
    return isDark ? '#BCBAB8' :'#686665';
  } else {
    return '#686665';
  }
};

export const plansButton = (type) => {
  if(type === 'entry'){
    return plansEntryButton;
  } else if(type === 'premium'){
    return plansPremiumButton;
  } else if(type === 'elite'){
    return plansEliteButton;
  } else if(type === 'fuel'){
    return plansPetrolButton;
  } else {
    return plansEntryButton;
  }
};

export const stylePlansTableTdColors = (type, isDark) => {
  if(type === 'entry'){
    return {
      borderBottom: isDark 
        ? '1px solid #262D47'
        : '1px solid #E3E8F0',
      background: !isDark 
        ? 'linear-gradient(0deg, #F7E9DA 0%, #F7E9DA 100%), #FFF'
        : 'linear-gradient(0deg, rgba(206, 133, 63, 0.10) 0%, rgba(206, 133, 63, 0.10) 100%), #0E1633'
    };
  } else if(type === 'premium'){
    return {
      borderBottom: isDark 
        ? '1px solid #262D47'
        : '1px solid #E3E8F0',
      background: !isDark 
        ? '#F2EDFB'
        : 'linear-gradient(0deg, rgba(119, 63, 206, 0.10) 0%, rgba(119, 63, 206, 0.10) 100%), #0E1633'
    };
  } else if(type === 'elite'){
    return {
      borderBottom: isDark 
        ? '1px solid #262D47'
        : '1px solid #E3E8F0',
      background: !isDark 
        ? 'linear-gradient(0deg, #FBF2DF 0%, #FBF2DF 100%), #FFF'
        : 'linear-gradient(0deg, rgba(225, 163, 26, 0.10) 0%, rgba(225, 163, 26, 0.10) 100%), #0E1633'
    };
  } else if(type === 'fuel'){
    return {
      borderBottom: isDark 
        ? '1px solid #262D47'
        : '1px solid #E3E8F0',
      background: !isDark 
        ? 'linear-gradient(0deg, #EFEFEF 0%, #EFEFEF 100%), #FFF'
        : 'linear-gradient(0deg, rgba(188, 186, 184, 0.10) 0%, rgba(188, 186, 184, 0.10) 100%), #0E1633'
    };
  } 
};

export const stylePlansTableTh = (type) => {
  if(type === 'entry'){
    return {
      background: 'linear-gradient(329deg, #CE853F 10.12%, #DB8C40 27.21%, #E3964D 43.55%, #FFB36B 69.55%, #FFC894 84.4%)'
    };
  } else if(type === 'premium'){
    return {
      background: `url(${particlesImage})`,
      backgroundColor: '#874DE3'
    };
  } else if(type === 'elite'){
    return {
      background: 'linear-gradient(352deg, #E1A31A 14.49%, #EAB639 46.41%, #F6CE5F 90.29%, #FCDD76 124.87%, #FFE27F 147.47%)'
    };
  } else if(type === 'fuel') {
    return {
      background: `url(${petrolImage})`,
    };
  } else {
    return {
      background: 'linear-gradient(180deg, #2ABDFD 0%, #0497FD 100%)'
    };
  }
};

export const plansItemIconBgColor = (type) => {
  if(type === 'entry'){
    return 'linear-gradient(329deg, #CE853F 10.12%, #DB8C40 27.21%, #E3964D 43.55%, #FFB36B 69.55%, #FFC894 84.4%)';
  } else if(type === 'premium'){
    return 'linear-gradient(329deg, #773FCE 10.12%, #7C40DB 27.21%, #874DE3 43.55%, #A56BFF 69.55%, #B689FD 84.4%)';
  } else if(type === 'elite'){
    return 'linear-gradient(333deg, #E1A31A 9.41%, #EAB639 36.49%, #F6CE5F 73.73%, #FCDD76 103.07%, #FFE27F 122.25%)';
  } else if(type === 'fuel'){
    return 'linear-gradient(180deg, #BCBAB8 0%, #686665 100%)';
  } else {
    return 'transparent';
  }
};

export const plansItemSaleTextColor = (type) => {
  if(type === 'entry'){
    return 'linear-gradient(329deg, #CE853F 10.12%, #DB8C40 27.21%, #E3964D 43.55%, #FFB36B 69.55%, #FFC894 84.4%)';
  } else if(type === 'premium'){
    return 'linear-gradient(329deg, #773FCE 10.12%, #7C40DB 27.21%, #874DE3 43.55%, #A56BFF 69.55%, #B689FD 84.4%)';
  } else if(type === 'elite'){
    return 'linear-gradient(333deg, #E1A31A 9.41%, #EAB639 36.49%, #F6CE5F 73.73%, #FCDD76 103.07%, #FFE27F 122.25%)';
  } 
};

export const getLinkLoyaltyMembership = () => {
  return 'https://lmctgiveaway.com/loyalty-membership';
};

export const getLinkPetrolMembership = () => {
  return 'https://lmctgiveaway.com/order-639460901777617719067';
};

export const getMonthName = (month) => {
  if (month < 1 || month > 12) { return ''; }
  return new Intl.DateTimeFormat('en-US', { month: 'long' }).format(new Date(2000, month - 1, 1));
};

export const isValidPassword = (password) => 
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/.test(password);